module.exports = __webpack_public_path__ + "static/conflict_card_img3@2x-65c76a8eaf86b7e963581325cbd7ae46.jpg";